<add-course-dialog-svg-sprite></add-course-dialog-svg-sprite>

<div class="add-course-dialog" [formGroup]="form">

  <div class="add-course-dialog-head">
    <div class="dialog-title">
      <svg class="dialog-title-icon">
        <use xlink:href="#courseDialogTitle"></use>
      </svg>
      <span class="dialog-title-text">Create New Course</span>
    </div>

    <a class="dialog-close-x" (click)="close()">
      <svg class="dialog-close-x-icon">
        <use xlink:href="#courseDialogXBtn"></use>
      </svg>
    </a>

  </div>

  <div class="add-course-dialog-contant">

    <div class="add-course-dialog-step-1" *ngIf="prevsection">

      <!--span class="dialog-contant-title-text">Select Course Type</span-->

      <div class="dialog-select-panel" [ngClass]="{'active': selectedItem == 'premium'}"
        (click)="listClick($event, 'premium')">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#courseCert"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Standard Premium Course</span>
          <span class="panel-desc">{{standardCourseDescription}}</span>
        </div>

      </div>

      <div class="dialog-select-panel" [ngClass]="{'active': selectedItem == 'privateCourseOn'}"
        (click)="listClick($event, 'privateCourseOn')">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#courseShieldCheck"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Private Course</span>
          <span class="panel-desc">{{privateCourseDescription}}</span>
        </div>

      </div>

      <div class="dialog-select-panel" [ngClass]="{'active': selectedItem == 'hiddenCourseOn'}"
        (click)="listClick($event, 'hiddenCourseOn')">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#eyeHide" class="svg-icon"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Hidden Course</span>
          <span class="panel-desc">{{hiddenCourseDescription}}</span>
        </div>

      </div>

      <div class="dialog-select-panel" [ngClass]="{'active': selectedItem == 'free'}"
        (click)="listClick($event, 'free')">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#courseSealCheck"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Free Course</span>
          <span class="panel-desc">{{freeCourseDescription}}</span>
        </div>

      </div>

    </div>

    <div class="add-course-dialog-step-2" *ngIf="nextsection">

      <span class="dialog-contant-title-text">Course Information</span>

      <div class="dialog-select-panel" *ngIf="selectedItem == 'premium'">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#courseCert"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Standard Premium Course</span>
          <span class="panel-desc">{{standardCourseDescription}}</span>
        </div>

      </div>

      <div class="dialog-select-panel" *ngIf="selectedItem == 'privateCourseOn'">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#courseShieldCheck"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Private Course</span>
          <span class="panel-desc">{{privateCourseDescription}}</span>
        </div>

      </div>

      <div class="dialog-select-panel" *ngIf="selectedItem == 'hiddenCourseOn'">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#eyeHide" class="svg-icon"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Hidden Course</span>
          <span class="panel-desc">{{hiddenCourseDescription}}</span>
        </div>

      </div>

      <div class="dialog-select-panel" *ngIf="selectedItem == 'free'">

        <div class="panel-icon-div">
          <svg class="panel-icon">
            <use xlink:href="#courseSealCheck"></use>
          </svg>
        </div>

        <div class="panel-desc-div">
          <span class="panel-title">Free Course</span>
          <span class="panel-desc">{{freeCourseDescription}}</span>
        </div>

      </div>

      <div class="form-group group-title">

        <span class="dialog-label course-title-text-label" for="course-title-label">Course Title&nbsp;&nbsp;<small
            class="dialog-limit course-title-limit">(Max 60 chars)</small></span>

        <input #titleHint type="text" class="form-control course-title-input" id="course-title-label"
          placeholder="Enter the course title" maxLength="60" formControlName="title">

        <small class="live-hint title-hint">
          {{titleHint.value.length}} / 60
        </small>

      </div>

      <div class="form-group group-desc">

        <span class="dialog-label course-desc-text-label" for="course-desc-label">Short Description&nbsp;&nbsp;<small
            class="dialog-limit course-desc-limit">(Max 98 chars)</small></span>

        <textarea #shortDescrHint class="form-control form-textfield course-desc-textarea" id="course-desc-label"
          placeholder="Enter just a short description for the course" formControlName="shortDescription" maxLength="98"
          rows="3">
        </textarea>

        <small class="live-hint desc-hint">
          {{shortDescrHint.value.length}} / 98
        </small>

      </div>

    </div>

  </div>

  <div class="add-course-dialog-footer" [ngStyle]="{'justify-content': prevsection ? 'end' : 'space-between' }">

    <a class="dialog-back-btn" (click)="back()" *ngIf="backbtn">
      <svg class="dialog-back-btn-icon">
        <use xlink:href="#arrowLeft"></use>
      </svg>
      <span class="dialog-back-btn-text">Back</span>
    </a>

    <div class="dialog-footer-btn-group">

      <a class="dialog-close-btn" (click)="close()">
        <svg class="dialog-close-btn-icon">
          <use xlink:href="#btnClose"></use>
        </svg>
        <span class="dialog-close-btn-text">Close</span>
      </a>

      <a class="dialog-next-btn" (click)="next()" *ngIf="nextbtn && selectedItem">
        <span class="dialog-next-btn-text">Next</span>
        <svg class="dialog-next-btn-icon">
          <use xlink:href="#arrowRight"></use>
        </svg>
      </a>

      <button class="dialog-save-btn" (click)="save()" [disabled]="!form.valid" *ngIf="savebtn">
        <svg *ngIf="!form.valid" class="dialog-save-btn-icon">
          <use xlink:href="#btnDisabled"></use>
        </svg>
        <svg *ngIf="form.valid"  class="dialog-save-btn-icon">
          <use xlink:href="#btnActive"></use>
        </svg>
        <span class="dialog-save-btn-text">Create Course</span>
      </button>

    </div>

  </div>

</div>